import { Link } from "@inertiajs/react";
import { useRef, useState, useEffect } from "react";
import { HomeSectionLayout } from "../../../../../components/HomeSectionLayout";
import { FeaturedContentItem } from "../index";
import { BreadCrumbs } from "../../../../../components/BreadCrumbs";
import RichMarkdownContent from "../../../../Announcements/RichMarkdownContent";
import { SECTION_COLORS } from "../../../../../utils/colors";

interface AnnouncementItem extends FeaturedContentItem {
  title: string;
  content?: string;
  text_preview?: string;
  image_url?: string;
  published_at?: string;
}

const MAX_HEIGHT = 600;

export default function AnnouncementSection({ item, index }: { item: FeaturedContentItem; index: number }) {
  const announcement = item as AnnouncementItem;
  const colors = SECTION_COLORS[index % SECTION_COLORS.length];
  const contentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (contentRef.current) {
      setIsOverflowing(contentRef.current.scrollHeight > MAX_HEIGHT);
    }
  }, [announcement.content]);

  return (
    <HomeSectionLayout.Container style={{
      backgroundColor: colors.bg,
      color: colors.text,
    }}>
      <div style={{
        width: '100%'
      }}>
        <HomeSectionLayout.HeaderDescription>
          <BreadCrumbs.Container>
            <BreadCrumbs.LinkItem href="/reference">
              Announcements
            </BreadCrumbs.LinkItem>
          </BreadCrumbs.Container>
        </HomeSectionLayout.HeaderDescription>
        <HomeSectionLayout.Header>
          {announcement.title}
        </HomeSectionLayout.Header>
      </div>
      <HomeSectionLayout.Content style={{
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '20px',
          width: '100%'
        }}>
          <div style={{
            flex: 1,
            width: '100%',
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: '10px',
            flexShrink: 0
          }}>
            <div style={{
              position: 'relative',
              maxHeight: isOverflowing ? MAX_HEIGHT : undefined,
              overflow: isOverflowing ? 'hidden' : undefined,
            }}>
              <div
                ref={contentRef}
                style={{
                  fontSize: '1.1rem',
                  lineHeight: '1.8',
                  textAlign: 'justify',
                  width: '100%',
                }}
              >
                <RichMarkdownContent>
                  {announcement.content}
                </RichMarkdownContent>
              </div>
              {isOverflowing && (
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '80px',
                  background: `linear-gradient(to bottom, transparent, ${colors.bg})`,
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'center',
                  paddingBottom: '10px',
                }}>
                  <Link
                    href={`/announcements/${announcement.id}`}
                    className="btn btn-light btn-sm"
                    style={{
                      padding: '8px 24px',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      textDecoration: 'none',
                    }}
                  >
                    Read More
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </HomeSectionLayout.Content>
    </HomeSectionLayout.Container>
  )
}
